import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import Button from '../../components/Button';
import Input from '../../components/Input';
import { useAuth } from '../../../hooks/auth';
import regex from "../../../utils/regex";
import { analyticsApi } from '../../../services/analytics';

const SignIn = () => {
  const [email, setEmail] = useState<string>('');
  const [emailError, setEmailError] = useState<string>('');

  const [password, setPassword] = useState<string>('');
  const [passwordError, setPasswordError] = useState<string>('');

  const auth = useAuth();

  useEffect(() => {
    analyticsApi.logEvent(
      '',
      'View',
      {},
      'SignIn'
    );
  }, []);

  useEffect(() => {
    if (!auth.isLoading && auth.isAuthenticated) {
      window.location.href = '/tracker';
    }
  }, [auth.isLoading, auth.isAuthenticated]);

  const login = async () => {
    analyticsApi.logEvent(
      '',
      'Action',
      { page: 'SignIn' },
      'Sign In Clicked',
    );
    validate();
    if (!emailError && !passwordError) {
      const response = await auth.signIn(email, password);
      if (response && response.error) {
        setEmailError(response.message);
      } else {
        setEmailError('')
      }
    }
  };

  const validate = () => {
    if (!regex.email.test(email)) {
      setEmailError('Please enter a valid email address.');
    } else {
      setEmailError('')
    }
  }

  return (
    <>
      <div className={styles.body}>
        <div className={'w100'}>
          <h1 className={`scene_title`}>Sign In</h1>
        </div>
        <div className={'w100'}>
          <Input
            hasError={!!emailError}
            errorMessage={emailError}
            value={email}
            onChange={setEmail}
            type={'text'}
            placeholder={'Enter email'}
            label={'Your email'}
          />
          <Input
            hasError={!!passwordError}
            errorMessage={passwordError}
            value={password}
            onChange={setPassword}
            type={'password'}
            placeholder={'Enter password'}
            label={'Password'}
          />
          <a href="/forgot"
             className={styles.forgot_pwd}
             onClick={() => analyticsApi.logEvent(
               '',
               'Action',
               {},
               'Forgot Password Clicked'
             )}
          >Forgot your password?</a>
        </div>
        <Button type={'default'} onClick={login}>
          Continue
        </Button>
      </div>
      <div className={styles.footer}>
        By continuing you agree to our <br />
        <a href="https://myorganicapps.com/en/terms.html" target="_blank">Terms of Service</a> | <a href="https://myorganicapps.com/en/privacy.html" target="_blank">Privacy Policy</a> |{' '}
        <a href="https://myorganicapps.com/en/money-back-policy.html" target="_blank">Money Back Policy</a> <br />
        2021. All rights reserved.
      </div>
    </>
  );
};

export default SignIn;
